import { NextPage } from 'next';
import { Box, VStack } from '@chakra-ui/react';
import { Testimonials } from '@components/home';
import { LayoutContainer, RoundedCorner } from '@components/common';
import { singlePageProps } from '@lib';
import {
  AuthUserComponents,
  B2BComponents,
  Hero,
  Customization
} from '@components/components';
import React from 'react';

const Components: NextPage = () => {
  return (
    <>
      <LayoutContainer
        verticalPadding="lg"
        pos="relative"
        bg="background"
        bgGradient="linear(to-br, #201864 0%, #101446 40%, #201864 100%)"
        pt={{ base: '72px', sm: '0px' }}
      >
        <Hero />
      </LayoutContainer>
      <LayoutContainer
        verticalPadding="md"
        pos="relative"
        bgGradient="linear(to-b, #F8F9FC 0%, #E8E4FF 50%,  #F8F9FC 100%)"
      >
        <RoundedCorner
          canvasHeight={160}
          bg="#13144B"
          yPosition="top"
          xPosition="left"
          flip
        />
        <RoundedCorner
          canvasHeight={160}
          bg="#1F1863"
          yPosition="top"
          xPosition="right"
          flip
        />
        <VStack
          gap={{ base: '48px', xl: '120px' }}
          justifyContent={'center'}
          pos="relative"
          pb="48px"
        >
          <Box
            id="auth-user-components"
            visibility="hidden"
            pos="relative"
            top={-250}
          />

          <AuthUserComponents />
          <Box
            id="b2b-components"
            visibility="hidden"
            pos="relative"
            top={-250}
          />
          <B2BComponents />
          <Box
            id="customization"
            visibility="hidden"
            pos="relative"
            top={-250}
          />
          <Customization />
        </VStack>
      </LayoutContainer>
      <LayoutContainer verticalPadding="none" pos="relative" bg="white">
        <RoundedCorner
          canvasHeight={160}
          bg="#F8F9FC"
          yPosition="top"
          xPosition="left"
          flip
        />
        <RoundedCorner
          canvasHeight={160}
          bg="#F8F9FC"
          yPosition="top"
          xPosition="right"
          flip
        />
        <Testimonials />
      </LayoutContainer>
    </>
  );
};

export default Components;

export async function getStaticProps({ preview = false }) {
  return singlePageProps({ preview, slug: '/components' });
}
